import MonopolioIcon from '@/assets/svg/monopolio-icon.svg'
import { SortDropdown } from '@/components/SortDropdown'
import { AmplitudeEvents } from '@/interfaces/enum'
import { setNewQueryParams } from '@/utils/routes'
import { useFilterStore, usePropertiesStore } from '@wiggot/search-components/state-library/src'
import { useAmplitude } from '@wiggot/analytics/src/providers/amplitud-provider/AmplitudeProvider'
import { getMacrobolsaUser } from '@wiggot/apis-ssr/utils/macrobolsa/get-macrobolsa-user-status-client'
import useMatchWindowQuery from '@wiggot/web-components/hooks/ds/useMatchWindowQuery'
import { Tooltip } from '@dd3tech/wiggui'
import Divider from '@dd3tech/wiggui/Divider'
import GoogleIcon from '@dd3tech/wiggui/GoogleIcon'
import Image from 'next/image'
import { CustomSwitch } from './CustomSwitch'

export const ORDER_OPTIONS = [
  { option: 'Más recientes', id: 'Recién publicadas' },
  { option: 'Menor a mayor precio', id: 'Menor a mayor precio' },
  { option: 'Mayor a menor precio', id: 'Mayor a menor precio' }
]

interface IProps {
  hiddeMap: boolean
  mapboxGLIsSupported: boolean
  onShowMap: () => void
  onChangeShowSideInfo: () => void
}

export const ListHeader = ({
  hiddeMap,
  mapboxGLIsSupported,
  onShowMap,
  onChangeShowSideInfo
}: IProps) => {
  const { trackEvent, isInitialized } = useAmplitude()
  const { hasMacrobolsaNotAdvancedUser } = getMacrobolsaUser()
  const { isMD } = useMatchWindowQuery()
  const { page } = usePropertiesStore()
  // const {
  //   setShowOnlyCommissionProperties,
  //   showOnlyCommissionProperties,
  //   setPropertyOrder,
  //   propertyOrder
  // } = useFilterStore()

  const { setListingsSource, listingsSource, setPropertyOrder, propertyOrder } =
    useFilterStore()
  const totalProperties = page?.totalItems?.toLocaleString() || '0'
  return (
    <div className="w-full flex justify-between items-center h-auto mb-2 px-1 md:px-0">
      <p className="text-sm font-semibold flex-1 flex">
        Hay <span className="text-sm mx-1">{totalProperties}</span> propiedades
        disponibles
      </p>
      <div className="flex gap-2 items-center">
        {!hasMacrobolsaNotAdvancedUser && (
          <div className="reverse-div tour-search-step-2-1">
            <CustomSwitch
              id="commission-filter-toggle"
              label="Buscar en todo el mercado"
              // onToggle={(value) => {
              //   const switchValue = !value
              //   setShowOnlyCommissionProperties(switchValue)
              //   setNewQueryParams({ sharesCommision: switchValue })
              //   if (isInitialized) {
              //     trackEvent({
              //       name: AmplitudeEvents.SEARCH_RESULTS_SHARECOMMISSION_ACTION,
              //       eventProperties: {
              //         kind: switchValue
              //       }
              //     })
              //   }
              // }}
              // initialChecked={!showOnlyCommissionProperties}
              onToggle={(value) => {
                setListingsSource(value ? ('' as any) : 'wiggot')
                setNewQueryParams({
                  listingSource: value ? undefined : 'wiggot'
                })
                if (isInitialized) {
                  trackEvent({
                    name: AmplitudeEvents.SEARCH_RESULTS_SHARECOMMISSION_ACTION,
                    eventProperties: {
                      kind: value ? 'all' : 'not_all'
                    }
                  })
                }
              }}
              initialChecked={!listingsSource}
            />
          </div>
        )}
        <SortDropdown
          placeholder="Ordenar por"
          filter={propertyOrder}
          options={ORDER_OPTIONS}
          onClose={() => null}
          setFilters={(op) => {
            setPropertyOrder(op)
          }}
          onConfirm={() => null}
        />
        {hiddeMap && isMD && (
          <>
            <Divider className="!h-11 !w-[1px]" isVertical />
            <button
              onClick={onChangeShowSideInfo}
              type="button"
              className="flex gap-2 text-sm font-semibold bg-white justify-center items-center rounded-full border border-surface-strokes p-3 h-11"
            >
              Ver zona
              <Image src={MonopolioIcon} height={15} alt="monopolio" />
            </button>
            {mapboxGLIsSupported ? (
              <button
                onClick={onShowMap}
                type="button"
                className="flex gap-2 text-sm font-semibold bg-white justify-center items-center rounded-full border border-surface-strokes p-3 h-11"
              >
                Mostrar mapa
                <GoogleIcon className="text-xl" name="map" />
              </button>
            ) : (
              <Tooltip
                tooltipClassName="z-10"
                content={
                  <>
                    No disponible en esta versión de tu navegador.
                    <br />
                    Actualiza tu navegador o accede desde otro.
                  </>
                }
              >
                {' '}
                <button
                  disabled={!mapboxGLIsSupported}
                  onClick={() => null}
                  type="button"
                  className="flex gap-2 text-sm font-semibold bg-white justify-center items-center rounded-full border border-surface-strokes p-3 h-11"
                >
                  Mostrar mapa
                  <GoogleIcon className="text-xl" name="map" />
                </button>
              </Tooltip>
            )}
          </>
        )}
      </div>
    </div>
  )
}
